import { reduxForm } from 'redux-form';

import OwnerMembershipForm from './OwnerMembershipForm';

export default reduxForm({ form: 'addOwnerForm' })(OwnerMembershipForm as any) as any;
